import React from "react";
import { useNavigate } from "react-router-dom";
import { Gift, ChevronRight } from "lucide-react";
import { Card } from "../../../components/cards";

export const GivenCansShortcut: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div onClick={() => navigate("/given-can/create")} className="cursor-pointer">
      <Card hover padding="md">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <div className="bg-pink-50 text-pink-600 p-2.5 rounded-lg flex-shrink-0">
              <Gift className="w-5 h-5" />
            </div>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-gray-900">Distribution gratuite</p>
              <p className="text-xs text-gray-500">Enregistrer un échantillon donné</p>
            </div>
          </div>
          <ChevronRight className="w-4 h-4 text-gray-400 flex-shrink-0" />
        </div>
      </Card>
    </div>
  );
};
